const EURO_FORMATTER = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

/**
 * Formats a salary range as a German-localised currency display string.
 *
 * Examples:
 *   formatSalaryRange(3000, 5000) → "3.000 € - 5.000 €"
 *   formatSalaryRange(null, 5000) → "5.000 €"
 *   formatSalaryRange(3000, null) → "3.000 €"
 *   formatSalaryRange(null, null) → null
 */
export const formatSalaryRange = (salaryLow?: number | null, salaryHigh?: number | null): string | null => {
  if (salaryLow && salaryHigh) return `${EURO_FORMATTER.format(salaryLow)} - ${EURO_FORMATTER.format(salaryHigh)}`;
  if (salaryHigh) return EURO_FORMATTER.format(salaryHigh);
  if (salaryLow) return EURO_FORMATTER.format(salaryLow);
  return null;
};
